import Component from '../core/Component'
import Snippet from '../core/Snippet'

const defaults = {
    limit: 3,
    autoload: false
}

export default class Paginator extends Component {
    constructor(element) {
        super(element, defaults)

        this.isDisabled = false
        this.current = 0

        this.ref = {
            snippet: null
        }
    }

    prepare() {
        if (!('IntersectionObserver' in window)) {
            return
        }

        this.observer = new IntersectionObserver(this.handleIntersection, {
            root: null,
            rootMargin: '0px 0px 200px 0px'
        })

        this.observer.observe(this.element)

        this.element.addEventListener('click', this.handleClick)

        this.snippet = new Snippet(this.ref.snippet)
        this.snippet.afterUpdate = this.handleSnippetChange
        this.attachButtonClick()
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect()
        }
    }

    attachButtonClick = () => {
        const button = this.element.querySelector('[data-ref="Paginator:buttonMore"]')

        if (!button) {
            return
        }

        button.addEventListener('click', this.handleButtonClick)
    }

    handleSnippetChange = () => {
        this.attachButtonClick()
    }

    handleButtonClick = event => {
        if (!event.isTrusted) {
            return
        }

        this.current = 0
        this.isDisabled = false
    }

    handleIntersection = (entries, observer) => {
        const isIntersecting = entries.some(entry => entry.isIntersecting)

        if (!isIntersecting || this.isDisabled) {
            return
        }

        this.current++

        if (this.current >= this.options.limit) {
            this.isDisabled = true
        }

        const button = this.element.querySelector('[data-ref="Paginator:buttonMore"]')

        if (!button) {
            this.isDisabled = true
        } else {
            button.click()
        }
    }
}
